import styled from "styled-components";
import { Grid, Col, FormControl, FormGroup } from "react-bootstrap";
import CreditCard from "../../../images/card.svg";
import { Title, CtaButton } from "../Common/index.style";

export const Container = styled(Grid)`
  max-width: 750px;
  margin: 0 auto;
  padding: 3rem;
  margin-top: 10rem;
`;

export const Image = styled(Col)`
  max-width: 50%;
  height: 205px;
  margin: 2em auto;
  background: url(${CreditCard}) no-repeat;
  object-fit: cover;

  @media (max-width: 700px) {
    max-width: 100%;
  }
`;

export const ConfirmButton = styled(CtaButton)`
  float: right;
  width: calc(50% - 4rem);
  margin: 2rem 2rem 0 2rem;
  border: 2px solid #39b54a;
  height: 40px;
  width: 200px;
`;

export const PaymentTitle = styled(Title)``;

export const TextField = styled(FormControl)`
  height: 40px;
`;

export const CustomFormGroup = styled(FormGroup)`
  margin: 0;
`;
